module.exports = __webpack_public_path__ + "img/medal_2.69ced235.png";